module.exports = __webpack_public_path__ + "static/media/sd.a16b5900.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sd.svg
// module id = 2204
// module chunks = 0